/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Legends_Periods_AriaInputs */

const en_directory_hubs_legends_periods_aria = /** @type {(inputs: Directory_Hubs_Legends_Periods_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch Legends periods`)
};

const zh_directory_hubs_legends_periods_aria = /** @type {(inputs: Directory_Hubs_Legends_Periods_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`传奇发布周期`)
};

/**
* | output |
* | --- |
* | "Launch Legends periods" |
*
* @param {Directory_Hubs_Legends_Periods_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_legends_periods_aria = /** @type {((inputs?: Directory_Hubs_Legends_Periods_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Legends_Periods_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_legends_periods_aria(inputs)
	return zh_directory_hubs_legends_periods_aria(inputs)
});
export { directory_hubs_legends_periods_aria as "directory.hubs.legends_periods_aria" }